// extracted by mini-css-extract-plugin
export default {"letter-button":"Grid_letter-button__hwHUY","letter-button-disabled":"Grid_letter-button-disabled__Jl+zy","td-cell":"Grid_td-cell__iIJ+y"};